import * as React from 'react';
import Box from '@material-ui/core/Box';
import IconButton from '@material-ui/core/IconButton';
import Collapse from '@material-ui/core/Collapse';
import Button from '@material-ui/core/Button';
import CloseIcon from '@material-ui/icons/Close';
import FileCopyIcon from '@material-ui/icons/FileCopy';
import Paper from '@material-ui/core/Paper';
import { TextField } from '@material-ui/core';


export default function InvitationGenerator(props) {
  const [open, setOpen] = React.useState(false);
  const getRegistrationUrl = props.getRegistrationUrl;
  const copyCodeToClipboard = props.copyCodeToClipboard;
  const generateRegistrationKey = props.generateRegistrationKey
  return (
    <Box width='55%'
      display="flex"
      flexDirection="column"
      >
      <Box width="130px" alignSelf="flex-end" display="flex">
      <Button
        size="medium"
        disabled={open}
        variant="outlined"
        onClick={() => {
          setOpen(true);
        }}
      >
        Invitation
      </Button>
      </Box>
      <Collapse in={open}>
        <Paper style={{marginTop: "15px" ,padding: "5px", height:"85px", display:"flex",alignItems: "center", justifyContent: "space-around", position: "relative", background: "rgb(236 237 238)"}}>
        <Button
          variant="outlined"
          onClick={generateRegistrationKey}
          >
            Generate Url
          </Button>
          <Box style={{display: 'flex', width: "75%"}}>       
          <TextField
            id="registrationUrl"
            fullWidth
            value={getRegistrationUrl()}
            type="text"
            disabled
            variant="outlined"
          />
          <IconButton 
            onClick={() => copyCodeToClipboard()}
          >
          <FileCopyIcon  />
          </IconButton>
          </Box>
          <IconButton
            style={{position: 'absolute', top: "5px", right: "2px"}}
            aria-label="close"
            color="inherit"
            size="small"
            onClick={() => {
              setOpen(false);
            }}
          >
            <CloseIcon fontSize="inherit" />
          </IconButton>
        </Paper>
        
      </Collapse>
    </Box>
  );
}